"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var RelatedProductsCarousel = /*#__PURE__*/function (_ItemsCarousel) {
    _inherits(RelatedProductsCarousel, _ItemsCarousel);

    var _super = _createSuper(RelatedProductsCarousel);

    function RelatedProductsCarousel(id, options) {
      _classCallCheck(this, RelatedProductsCarousel);

      var OPTIONS_MANDATORY = {
        settings: {
          wrapAround: false
        }
      };
      options = $.extend(true, OPTIONS_MANDATORY, _.clone(options));
      return _super.call(this, id, options);
    }

    _createClass(RelatedProductsCarousel, [{
      key: "init",
      value: function init() {
        var _this = this;

        this.$domElement.find(".card.product-card ").each(function (i, el) {
          _get(_getPrototypeOf(RelatedProductsCarousel.prototype), "addModules", _this).call(_this, [new window.ProductCard(null, {
            $domElement: $(el)
          })]);
        });

        _get(_getPrototypeOf(RelatedProductsCarousel.prototype), "init", this).call(this);
      }
    }, {
      key: "onReady",
      value: function onReady() {
        // console.log('ON_DOCUMENT_READYON_DOCUMENT_READYON_DOCUMENT_READY');
        // console.log('this.$domElement', this.$domElement);
        // console.log('CH', $('#shopify-section-product-recommendations'));
        // console.log('CHECK', this.$domElement.find(".product-card").length);
        if ($('#shopify-section-product-recommendations') && $('#shopify-section-product-recommendations').length > 0 && this.$domElement.find(".product-card").length > 0) {
          var products = [];
          this.$domElement.find(".product-card").each(function (i, el) {
            // console.log('TTTTT', i, el, $(el).attr('data-product-id'));
            var temp_pr = {
              item_id: $(el).attr('data-product-id').toString(),
              item_name: $(el).find('.product-name').text(),
              currency: Shopify.currency.active,
              index: i + 1,
              item_brand: $(el).find('.product-brand').text(),
              item_category: "Apparel",
              item_list_id: 'related_products',
              item_list_name: 'Related products',
              price: Number($(el).find('.product-price__final').text().toString().replace(/(\r\n|\n|\r)/gm, "").replace('€', '').replace('.', '').replace(',', '.')),
              quantity: 1
            };
            products.push(temp_pr);
          });
          /* console.log('dataLayerPush', {
              event: "view_item_list",
              ecommerce: {
                  items: products
              }
          }); */

          dataLayer.push({
            ecommerce: null
          });
          dataLayer.push({
            event: "view_item_list",
            ecommerce: {
              items: products
            }
          });
        }

        _get(_getPrototypeOf(RelatedProductsCarousel.prototype), "onReady", this).call(this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        _get(_getPrototypeOf(RelatedProductsCarousel.prototype), "dispose", this).call(this);
      }
    }]);

    return RelatedProductsCarousel;
  }(ItemsCarousel);

  window.RelatedProductsCarousel = RelatedProductsCarousel;
})(window);
